"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var moment_timezone_1 = __importDefault(require("moment-timezone"));
var DateTimeCheckService = (function () {
    function DateTimeCheckService() {
    }
    DateTimeCheckService.checkNextTimeForObject = function (obj, nextMoment) {
        return (this.checkDateResolution(obj, nextMoment) &&
            this.checkDayResolution(obj, nextMoment) &&
            this.checkTimeResolution(obj, nextMoment));
    };
    DateTimeCheckService.getStartEndDatesForObj = function (obj) {
        var asMoment = function (date) { return (date ? (0, moment_timezone_1.default)(date) : date); };
        if ("startDate" in obj)
            return [asMoment(obj.startDate), asMoment(obj.endDate)];
        if ("startCompany" in obj)
            return [asMoment(obj.startCompany), asMoment(obj.endCompany)];
        return [null, null];
    };
    DateTimeCheckService.checkDateResolution = function (obj, nextMoment) {
        var _a = __read(this.getStartEndDatesForObj(obj), 2), start = _a[0], end = _a[1];
        if (start && nextMoment.isBefore(start))
            return false;
        if (end && nextMoment.isAfter(end))
            return false;
        return true;
    };
    DateTimeCheckService.checkDayResolution = function (obj, nextMoment) {
        var _a;
        if (!((_a = obj === null || obj === void 0 ? void 0 : obj.days) === null || _a === void 0 ? void 0 : _a.length)) {
            return true;
        }
        var weekDay = nextMoment.isoWeekday();
        return obj.days.includes(weekDay);
    };
    DateTimeCheckService.checkTimeResolution = function (obj, nextMoment) {
        if (!obj.startDayTime || !obj.endDayTime)
            return true;
        if (nextMoment.hours() === 23 && nextMoment.minutes() === 59)
            return false;
        var startTimeInMinutes = obj.startDayTime.h * 60 + obj.startDayTime.m;
        var endTimeInMinutes = obj.endDayTime.h * 60 + obj.endDayTime.m;
        var nextMomentInMinutes = nextMoment.diff(nextMoment.clone().startOf("day"), "minutes");
        if (startTimeInMinutes <= endTimeInMinutes) {
            if (nextMomentInMinutes >= startTimeInMinutes && nextMomentInMinutes <= endTimeInMinutes) {
                return true;
            }
        }
        else {
            if (nextMomentInMinutes >= startTimeInMinutes || nextMomentInMinutes <= endTimeInMinutes) {
                return true;
            }
        }
        return false;
    };
    return DateTimeCheckService;
}());
exports.default = DateTimeCheckService;
//# sourceMappingURL=index.js.map